export default {
	title: "Monitoraggio",
	url: "monitoraggio",
	subtitle: "Rapporto di monitoraggio strategico generato tramite ricerca anonimizzata: il tema del progetto viene neutralizzato prima di qualsiasi interrogazione di fonti pubbliche. Il rapporto copre il contesto macro (PESTEL), settoriale (5 forze di Porter) e interno, con segnali forti e deboli.",
	current: "Rapporto attuale",
	archive: "Archivi",
	context_tab: "Contesto",
	empty: "Nessun rapporto di monitoraggio per questo progetto.",
	generated_on: "Redatto il",
	actions: {
		generate: "Genera un rapporto",
		generate_new: "Genera un nuovo rapporto",
		generating: "Generazione in corso… (circa dieci minuti)",
		retry: "Riprova",
		print: "Stampa",
		delete: "Elimina questo rapporto",
		delete_confirm: "Eliminare definitivamente questo rapporto?"
	},
	steps: {
		anonymizing: "Anonimizzazione del tema",
		researching: "Ricerca e redazione",
		done: "Rapporto disponibile",
		elapsed: "da {{minutes}} min"
	},
	messages: {
		failed: "Generazione non riuscita",
		neutral_subject: "Tema anonimizzato inviato",
		confirm_title: "Avviare un monitoraggio anonimizzato?",
		confirm_body: "Il tema del progetto sarà anonimizzato prima di qualsiasi ricerca su fonti pubbliche. La generazione del rapporto richiede circa dieci minuti."
	}
};
